











import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class TextFoldingArea extends Vue {
  folding = false

  handleFolding () {
    this.folding = !this.folding
  }
}
